/* eslint-disable */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Grid,
  Box,
  Theme,
  makeStyles,
  createStyles,
  Link as MUILink,
} from '@material-ui/core';
import {
  Header,
  Page,
  Content,
  ContentHeader,
  SupportButton,
  Link,
  InfoCard,
} from '@backstage/core-components';
import Create from '@mui/icons-material/Create';
import LiveHelp from '@material-ui/icons/LiveHelp';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AssignmentIcon from '@mui/icons-material/Assignment';
import MapIcon from '@mui/icons-material/Map';
import LocationIcon from '@material-ui/icons/MyLocation';
import SecurityIcon from '@mui/icons-material/Security';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import './homepage.css';
// import AcuityLogoLight from '../../assets/acuitybrands-green.svg';
import AcuityLogoLight from '../../assets/Logo_Acuity_Brands_Main.svg';
import AcuityLogoDark from '../../assets/acuitybrands-white.svg';
import Typography from '@material-ui/core/Typography';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { appThemeApiRef, useApi } from '@backstage/core-plugin-api';
import UserFetchComponent from './userCards/userFetch';
import BannerWidget from './bannerComponent/bannerWidget';
import {
  Banner,
  BannerInfoForWidget,
  BannerWidgetData,
  useBanner,
} from './bannerComponent/bannerContext';

import TechdocsOnboardingBanner from './bannerComponent/techdocsOnboardingBanner';

import {
  HomePageTopVisited,
  HomePageRecentlyVisited,
} from '@backstage/plugin-home';

const Logo = () => {
  const themeApi = useApi(appThemeApiRef);
  const logoStyle = {
    width: '400px', // Set the desired width
    height: 'auto', // Maintain aspect ratio
  };
  if (themeApi.getActiveThemeId() === 'dark-theme')
    return <img src={AcuityLogoDark} alt="Acuity Brands" />;

  return <img src={AcuityLogoLight} alt="Acuity Brands" style={logoStyle} />;
};

const returnPrimary = () => {
  const themeApi = useApi(appThemeApiRef);
  return themeApi.getActiveThemeId() === 'dark-theme' ? '#333' : '#fff';
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    divider: {
      margin: '50px 0 30px',
    },
    iconContainer: {
      display: 'flex',
      margin: '40px 0',
    },
    iconLink: {
      textAlign: 'center',
      width: '115px',
      marginRight: '40px',
      '&:hover': {
        textDecoration: 'none',
      },
    },
    iconWrapper: {
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
    },
    icon: {
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.light,
      height: '70px',
      width: '70px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '10px',
      '&:hover': {
        backgroundColor: theme.palette.primary.light,
      },
    },
    label: {
      fontWeight: 'bold',
      color: theme.palette.secondary.default,
    },
  }),
);

export const HomePage = () => {
  const { updateBanner } = useBanner();
  const classes = useStyles();
  const quickLinks = [
    {
      url: '/create/templates/default/securityexception',
      label: 'File a Security Exception',
      icon: <AssignmentIcon htmlColor={returnPrimary()} />,
    },
    {
      url: '/create/templates/default/postmortemmd',
      label: 'File a Postmortem',
      icon: <CoPresentIcon htmlColor={returnPrimary()} />,
    },
    {
      url: '/create/templates/default/api-test-runner-template-azure',
      label: 'Setup API TestRunner',
      icon: <Create htmlColor={returnPrimary()} />,
    },
    {
      url: '/docs/default/component/zephyr-techdocs/product-documentation/user/end-user/techdocs/',
      label: 'Onboard to TechDocs',
      icon: <MapIcon htmlColor={returnPrimary()} />,
    },
    {
      url: '/docs/default/component/zephyr-techdocs/product-documentation/user/end-user/tech-radars/',
      label: 'Create a Tech Radar',
      icon: <LocationIcon htmlColor={returnPrimary()} />,
    },
    {
      url: 'https://isthub.acuitybrands.com/',
      label: 'ABL Tech Hub',
      icon: <LiveHelp htmlColor={returnPrimary()} />,
    },
    {
      url: 'https://acuitybrandsinc.sharepoint.com/sites/ProductSecurity',
      label: 'Product Security',
      icon: <SecurityIcon htmlColor={returnPrimary()} />,
    },
  ];

  const bannerInformation: BannerWidgetData = {
    BannerData: {
      // when adding your new announcement, you wil need to pass in a string UUID to the compnent as well. This can be any string you want as long as its unique in some form.
      // This UUID will be stored in the bannerContext object for the user.
      UUID: '05/15/2023',

      // When adding links to your new announcement, use the updateBanner() on the onClick prop so that when users click on the link, it updates the context so banner isn't shown again.
      announcement: (
        <>
          <Typography>
            <span
              style={{ fontWeight: 'bold', fontSize: '14px', color: 'black' }}
            >
              Hey! Thank you for using the portal.
            </span>{' '}
            <span style={{ fontSize: '14px', color: 'black' }}>
              We have a lot of tools to get you where you need to be quickly.
            </span>
          </Typography>

          {/* // example of handling links
           <MUILink onClick={_e =>{ updateBanner({
            hasBeenSeen: true,
            bannerUUID: "someNewAnnouncementUDID"
           })}} style={{ color: 'blue' }} target="_blank" href="https://ablcode.visualstudio.com/Zephyr/_boards/board/t/Zephyr%20Team/Features">Click Here!</MUILink> */}
        </>
      ),

      // color codes ["success" <- green, "warning" <- yellow]
      color: 'success',
    },
  };

  return (
    <Page themeId="tool">
      <Header title="Acuity Developer Portal" />
      <Content>
        {/* <BannerWidget
          announcementUUID={bannerInformation.BannerData.UUID}
          announcementText={bannerInformation.BannerData.announcement}
          bannerSeverity={bannerInformation.BannerData.color}
        /> */}
        <TechdocsOnboardingBanner />
        <ContentHeader title="">
          <SupportButton>
            <Typography variant="subtitle1" gutterBottom>
              Use the links below to reach out directly to the team if you have
              any questions, comments, or concerns.
            </Typography>
          </SupportButton>
        </ContentHeader>

        <Grid
          container
          xs={12}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <Grid item xs={12} spacing={0}>
            <Logo />
          </Grid>
          <Grid item md={9} xs={12} style={{ width: '100%' }}>
            <Box style={{ margin: '40px' }}>
              <HomePageSearchBar
                autoFocus
                placeholder="Search in the Developer Portal"
              />
            </Box>
          </Grid>
        </Grid>

        <Grid container xs={12}>
          <Grid item md={12}>
            <UserFetchComponent />
            <hr className={classes.divider} />
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <HomePageTopVisited />
            </Grid>
            <Grid item xs={12} md={6}>
              <HomePageRecentlyVisited />
            </Grid>
          </Grid>
          <Grid item md={12}>
            <hr className={classes.divider} />
            <h4>Quick Links</h4>
            <div className={classes.iconContainer}>
              {quickLinks.map(link => (
                <Link to={link.url} className={classes.iconLink}>
                  <div className={classes.iconWrapper}>
                    <div className={classes.icon}>{link.icon}</div>
                    <span className={classes.label}>{link.label}</span>
                  </div>
                </Link>
              ))}
            </div>
          </Grid>
          <Grid item md={6}></Grid>
        </Grid>
      </Content>
    </Page>
  );
};
